export default __webpack_public_path__ + "static/media/aboutHero.8a109c63.jpg";